// const Apiurl = "http://192.168.1.241:5000/api";
// const Apiurl = "http://192.168.1.245:5000/api";
// const Apiurl = "http://192.168.1.235:5000/api";
const Apiurl = "https://bs.aalantechsoft.com:5000/api";

export default Apiurl;
